<template lang="pug">
div
  template(v-if="isFetching")
    v-row(no-gutters)
      v-col(cols="8")
        v-skeleton-loader(type="article@3")
  template(v-else)
    //- For onboarding
    onboarding-review(v-if="!hasReviewAccount" :connectNow.sync="connectNow")
    //- For reconnecting
    google-business-page-setup-flow(v-if="googlePageSetup" redirectQueryParams="?google_page_setup=true" @cancel="cancelGooglePageSetup")
    //- Default page
    v-row(no-gutters :style="`min-height: ${viewHeight};`")
      v-col.px-6.shrink.white
        div.sticky(style="width: 216px; top: 106px;")
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 0 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(0)") Review settings
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 1 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(1)") Feedback form
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 2 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(2)") Offers & Deliverance
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 3 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(3)") QR code & link
          .text-md.font-semibold.px-6.py-2.round-md.mb-2(:class="step === 4 ? 'neutral200' : 'neutral500--text clickable'" @click="goToWindow(4)") Automation
    
      v-col.grow.neutral200
        v-container.pa-8(fluid style="max-width:1200px")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="goBack" height)
                v-icon(color="basic800" :size="24") mdi-arrow-left
            v-col.ml-3
              .text-2xl.font-semibold.neutral700--text Review settings

          v-window(v-model="step" touchless)
            v-window-item(:value="0")
              v-skeleton-loader(v-if="!hasReviewAccount || googlePageSetup" type="article@3")
              review-page-tab(v-else @googlePageSetup="googlePageSetup = true" :os="os")
            v-window-item(:value="1")
              feedback-form-tab
            v-window-item(:value="2")
              review-offer-deliverance
            v-window-item(:value="3")
              sharing-tab
            v-window-item(:value="4")
              automation-setup(:fetchingData="fetchingData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OnboardingReview from '@/components/review/general/OnboardingReview.vue'
import ReviewPageTab from '@/components/review/settings/ReviewPageTab.vue'
import FeedbackFormTab from '@/components/review/settings/FeedbackFormTab.vue'
import SharingTab from '@/components/review/settings/SharingTab.vue'
import AutomationSetup from '@/components/review/settings/AutomationSetup.vue'
import ReviewOfferDeliverance from '@/components/review/settings/ReviewOfferDeliverance.vue'
import GoogleBusinessPageSetupFlow from '@/components/review/settings/GoogleBusinessPageSetupFlow.vue'

export default {
  name: 'ReviewSettings',
  components: {
    ReviewPageTab,
    FeedbackFormTab,
    SharingTab,
    OnboardingReview,
    AutomationSetup,
    ReviewOfferDeliverance,
    GoogleBusinessPageSetupFlow
  },
  props: {
    os: {
      type: String,
      default: 'review',
      validator(value) {
        return ['clinic', 'donation', 'connect', 'review'].includes(value)
      }
    },
  },
  data() {
    return {
      step: 0,
      isFetching: false,
      fetchingData: null,
      googlePageSetup: false,
      connectNow: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      hasReviewAccount: 'review/hasFinishedSetup',
      displaySize: 'ui/getDisplaySize'
    }),
    viewHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '139vh'
        case 'x-small':
          return '124vh'
        case 'small':
          return '115vh'
        case 'medium':
          return '101vh'
        case 'large':
          return '90vh'
        case 'x-large':
          return '90vh'
        default:
          return '90vh'
      }
    }
  },
  async mounted() {
    this.isFetching = true
    const allFetching = [this.fetchSettings(), this.fetchGoogleAccount()]
    try {
      await Promise.all([...allFetching])
    } catch (error) {
      this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      return
    }
    this.checkRoute()
    this.isFetching = false
  },
  methods: {
    ...mapActions(['showMessage']),
    async fetchSettings() {
      return this.$axios.get(`/reviews/${this.company.slug}`).then(({ data }) => {
        this.fetchingData = data
        this.$store.commit('review/setSettings', data)
        this.$store.commit('review/setGoogleReviewUrl', data.google_review_url)
      })
    },
    fetchGoogleAccount() {
      return this.$axios.get(`reviews/${this.company.slug}/google`)
        .then(({ data }) => {
          this.$store.commit('review/setMainAccount', data)
        })
        .catch((error) => {
          if (error.response && error.response.status === 404) {
            return
          }
          throw error
        })
    },
    checkRoute() {
      if (this.$route.query?.connect_now === 'true') {
        this.connectNow = true
      }
      if (this.$route.query?.google_page_setup === 'true') {
        this.googlePageSetup = true
      }
      if (!this.hasReviewAccount) {
        return
      }
    },
    cancelGooglePageSetup() {
      this.googlePageSetup = false
    },
    goToWindow (step) {
      if (this.step !== step) {
        this.step = step
      }
    },
    goBack () {
      this.$router.go(-1)
    },
  },
}
</script>

<style scoped>
</style>